import React from 'react';
import { motion } from 'framer-motion';
export function WhatItIsNot() {
  return <section className="py-16 px-4 bg-gray-100" data-id="element-254">
      <div className="max-w-3xl mx-auto" data-id="element-255">
        {/* Esto NO es */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-8" data-id="element-256">
          <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-6 text-center" data-id="element-257">
            ❌ Esto NO es:
          </h3>
          <div className="space-y-3" data-id="element-258">
            {['Un libro aburrido lleno de teoría', 'Una dieta restrictiva imposible de seguir', 'Un plan que te obliga a contar calorías'].map((item, index) => <div key={index} className="bg-white px-5 py-4 rounded-xl flex items-center gap-3 text-lg text-gray-600 font-medium shadow-sm border border-red-100" data-id="element-259">
                <span className="text-red-500 flex-shrink-0 text-xl" data-id="element-260">✘</span>
                {item}
              </div>)}
          </div>
        </motion.div>

        {/* Esto SÍ es */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} data-id="element-261">
          <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-6 text-center" data-id="element-262">
            ✅ Esto SÍ es:
          </h3>
          <div className="bg-white px-6 py-6 rounded-xl shadow-sm border-2 border-green-400 text-center" data-id="element-263">
            <p className="text-xl md:text-2xl font-bold text-gray-800 leading-snug" data-id="element-264">
              Un sistema completo con recetas, guías y planes
              <span className="text-green-600" data-id="element-265"> listos para usar.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}